<template>
  <div class="wrapper-inner">
    <div class="banner">
      <div class="title">{{title}}</div>
      <div class="info">{{info}}</div>
    </div>
    <div class="content-inner" v-html="content"></div>
    <footerView></footerView>
  </div>
</template>
<script>
import footerView from "@/components/footerView.vue";
export default {
  components:{
    footerView
  },
  created() {
    this.content = this.$route.query.content
    this.title = this.$route.query.title
    this.info = this.$route.query.info
  },
  mounted() {
    // 页面加载时滚动到顶部
    window.scrollTo(0, 0);
  },
  watch:{
    '$route.query.title':{
      handler(newVal){
        this.content = this.$route.query.content
        this.title = this.$route.query.title
        this.info = this.$route.query.info
      },
      deep: true,
      immediate: true
    }
  },
  data(){
    return {
      title:'',
      info:'',
      content:'',
    }
  }
}
</script>
<style scoped lang="scss">
.wrapper-inner{
  background: #131415;
}
.banner{
  height: 540px;
  background: url(../../assets/images/product/banner.png) no-repeat center top;
  background-size: 100% auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  .title{
    font-size: 52px;
  }
  .info{
    font-size: 16px;
    text-align: center;
    width: 100%;
    line-height: 32px;
    margin-top: 16px;
  }
}
.content-inner{
  width: 1200px;
  margin: 20px auto;
  color: #fff;
  box-sizing: border-box;
  ::v-deep .con-title{
    font-size: 24px;
    line-height: 40px;
  }
  ::v-deep .content{
    margin-bottom: 20px;
    .content-item{
      font-size: 18px;
      line-height: 32px;
      opacity: .8;
      margin: 4px 0;
    }
  }
  ::v-deep .img-box{
    text-align: center;
  }
  ::v-deep img{
    max-width: 100%;
    height: auto;
  }
}
/* 大屏幕PC适配 */
@media screen and (min-width: 1600px) {
  .content-inner {
    width: 1400px;
    ::v-deep .con-title {
      font-size: 28px;
      line-height: 50px;
    }
    ::v-deep .content {
      .content-item {
        font-size: 20px;
        line-height: 36px;
      }
    }
  }
}

/* 中屏幕PC适配 (1400-1599px) */
@media screen and (max-width: 1599px) and (min-width: 1400px) {
  .content-inner {
    width: 1200px;
  }
}

/* 小屏幕PC适配 (1200-1399px) */
@media screen and (max-width: 1399px) and (min-width: 1200px) {
  .content-inner {
    width: 1000px;
    ::v-deep .con-title {
      font-size: 22px;
      line-height: 45px;
    }
    ::v-deep .content {
      .content-item {
        font-size: 17px;
        line-height: 34px;
      }
    }
  }
}

/* 大屏平板适配 (1025-1199px) */
@media screen and (max-width: 1199px) and (min-width: 1025px) {
  .content-inner {
    width: 900px;
    ::v-deep .con-title {
      font-size: 20px;
      line-height: 40px;
    }
  }
}

/* 平板设备适配 (769-1024px) */
@media screen and (max-width: 1024px) and (min-width: 769px) {
  .content-inner {
    width: 100%;
    padding: 0 24px;
    ::v-deep .con-title {
      font-size: 18px;
    }
    ::v-deep .content {
      .content-item {
        font-size: 15px;
        line-height: 30px;
      }
    }
  }
  .banner {
    height: 35vw;
  }
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .banner {
    height: 48vw;
    background: url(../../assets/images/product/banner-m.png) no-repeat;
    background-size: 100% auto;
    padding-top: 30px;
    box-sizing: border-box;

    .title {
      font-size: 18px;
      line-height: 30px;
    }

    .info {
      font-size: 14px;
      padding: 0 16px;
    }
  }
  .content-inner{
    width: 100%;
    padding: 0 16px;
    margin: 20px auto;
    color: #fff;
    ::v-deep .con-title{
      font-size: 16px;
      line-height: 40px;
    }
    ::v-deep .content{
      margin-bottom: 20px;
      .content-item{
        font-size: 14px;
        line-height: 32px;
        opacity: .8;
        margin: 4px 0;
      }
    }
    ::v-deep img{
      max-width: 100%;
      height: auto;
    }
  }
  
  /* 超小屏幕移动端适配 (小于480px) */
  @media screen and (max-width: 479px) {
    .banner {
      height: 60vw;
    }
    .content-inner {
      padding: 0 12px;
      ::v-deep .content {
        .content-item {
          font-size: 13px;
          line-height: 28px;
        }
      }
    }
  }
}
</style>
